import { render } from "./term.vue?vue&type=template&id=33175b56&scoped=true"
import script from "./term.vue?vue&type=script&lang=js"
export * from "./term.vue?vue&type=script&lang=js"

import "./term.vue?vue&type=style&index=0&id=33175b56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33175b56"]])

export default __exports__